﻿import "../app";
import "@fiqas/utils"
import { IIdentifiableCollectionOf, IResourceOf } from "../interfaces/iFqs"
import { WebLink } from "./base"

export interface GetPersonsResult extends IIdentifiableCollectionOf<CompactPerson> { }

export interface CompactPerson extends IResourceOf<Person> {
    name: string;
    isFiqasEmployee: boolean;
    isFormerEmployee: boolean;
    hasLogin: boolean;
}

export interface Person extends IResourceOf<Person>, PersonData { }

export interface PersonData {
    firstName: string;
    middleName: string;
    lastName: string;
    initials: string;
    email: string;
    phone: string[];
    name: string;
}

export interface FiqasEmployee extends Person { }
